import { Suspense, ReactNode } from 'react';
import { Card } from './Card';
import { Spinfinity } from '@repo/ui';
import { CardErrorBoundary } from './CardErrorBoundary';

interface CardErrorBoundaryWithSpinfinityProps {
  children: ReactNode;
  cardName?: string;
  cardVariant?: 'normal' | 'wrapper';
  cardClassName?: string;
  sentryContext?: Record<string, any>;
}

export const CardErrorBoundaryWithSpinfinity = ({
  children,
  cardName,
  cardVariant,
  cardClassName,
  sentryContext,
}: CardErrorBoundaryWithSpinfinityProps) => {
  return (
    <CardErrorBoundary
      cardName={cardName}
      cardVariant={cardVariant}
      cardClassName={cardClassName}
      sentryContext={sentryContext}
    >
      <Suspense
        fallback={
          <Card variant={cardVariant} className={cardClassName}>
            <Spinfinity />
          </Card>
        }
      >
        {children}
      </Suspense>
    </CardErrorBoundary>
  );
};
